import { render, staticRenderFns } from "./beneficiary-listing.component.vue?vue&type=template&id=80a4a6b6&"
import script from "./beneficiary-listing.component.vue?vue&type=script&lang=ts&"
export * from "./beneficiary-listing.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports